import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"search\"><path d=\"M5 8h1c0-1.1.9-2 2-2V5C6.34 5 5 6.34 5 8zm10.53 6.47l-2.79-2.79A5.976 5.976 0 0014 8c0-3.31-2.69-6-6-6S2 4.69 2 8s2.69 6 6 6c1.39 0 2.66-.47 3.68-1.26l2.79 2.79c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06zM8 12.5c-2.48 0-4.5-2.02-4.5-4.5S5.52 3.5 8 3.5s4.5 2.02 4.5 4.5-2.02 4.5-4.5 4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol